(function($){
    function setEqualHeight() {
        $('.equal-height').each(function() {
            for( var i = 0; i < 10; i++ ) {
                var items = $('.equal-height-item' + (i ? '--group-' + i : ''), this), height = 0;
                if (!items.length) continue;
                items.each(function() {
                    // detect visual composer markup
                    if ($(this).hasClass('wpb_column')) {
                        $('.wpb_wrapper:first', this).css('height', 'auto');
                    } else {
                        $(this).css('height', 'auto');
                    }
                    // use the height of the item, not .wpb_wrapper when VC detected
                    height = Math.max(height, $(this).outerHeight());
                });
                items.each(function() {
                    // detect visual composer markup
                    if ($(this).hasClass('wpb_column')) {
                        // set height on .wpb_wrapper, .wpb_column should only act as a container
                        $('.wpb_wrapper:first', this).outerHeight(height);
                    } else {
                        $(this).outerHeight(height);
                    }
                });
            }
        });
    }
    $(window).on('resize', _.throttle(setEqualHeight, 250));
    $(window).on('load', setEqualHeight);
    setEqualHeight();
})(jQuery);
